import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  supportsubject: null,
  supportmessage: null,
  loading: null,
  showlist: false,
  subjectlist: [],
  subjectloading: true,
  messageloading: true,
  messagedetails: [],
  inputmessage: null,
  pusherMessageDetails: null,
  defaultTicketId: null,
  appendMessage: null,
  subjectCreated: false,
  ticketStatus: null
};

const supportmodalSlice = createSlice({
  name: "supportmodal",
  initialState,
  reducers: {
    createSubjectStart: (state, action) => {
      state.supportmessage = action.payload.message;
      state.supportsubject = action.payload.subject;
      state.loading = true;
      state.subjectCreated = false;
    },
    createSubjectSuccess: (state, action) => {
      state.loading = false;
      state.subjectCreated = true;
    },
    createSubjectFailure: (state, action) => {
      state.loading = false;
      state.subjectCreated = false;
    },
    getSupportSubjectsStart: (state, action) => {
      state.showlist = true;
      state.subjectloading = true;
    },

    getSupportSubjectsSuccess: (state, action) => {
      state.subjectlist = action.payload;
      state.subjectloading = false;
      state.ticketStatus = initialState?.ticketStatus;
    },
    getSupportSubjectsFailure: (state, action) => {
      state.subjectloading = true;
    },
    getSupportMessagesStart: (state, action) => {
      state.handleticketid = action.payload;
      state.messageloading = true;
    },
    getSupportMessagesSuccess: (state, action) => {
      state.messagedetails = action.payload;
      state.messageloading = false;
      state.ticketStatus = initialState?.ticketStatus;
    },
    getSupportMessagesFailure: (state, action) => {
      state.messageloading = true;
    },
    createMessage: (state, action) => {
      state.inputmessage = action.payload;
    },

    pusherStart: (state, action) => {},

    pusherSuccess: (state, action) => {
      if (action?.payload?.ticketStatus) {
        state.ticketStatus = action?.payload?.ticketStatus;
      } else {
        state.appendMessage = action.payload;
      }
    },
    PusherUnsbscribe: (state, action) => {},
    resetQuerySent: (state, action) => {
      state.subjectCreated = initialState.subjectCreated;
    }
  }
});

export const {
  createSubjectStart,
  createSubjectSuccess,
  createSubjectFailure,
  getSupportSubjectsStart,
  getSupportSubjectsSuccess,
  getSupportSubjectsFailure,
  getSupportMessagesStart,
  getSupportMessagesSuccess,
  getSupportMessagesFailure,
  createMessage,
  pusherStart,
  pusherSuccess,
  PusherUnsbscribe,
  resetQuerySent
} = supportmodalSlice.actions;

export default supportmodalSlice.reducer;
